<template>
  <div v-if="loaded">
    <!-- <el-row type="flex" class="row-bg" justify="space-between"> -->
    <s-toolbar>
      <template slot="left">
        <el-button
            type="success"
            plain
            :disabled="processing"
            @click="download()"
            title="Download Excel">
          <fa
              icon="file-excel"
              fixed-width
              size="lg"></fa>
        </el-button>
        <div style="background: whitesmoke;padding: 2px" v-if="!displayVehicleRun">
          <s-remote-select
              labelProp="name"
              placeholder="Φίλτρο οχηματος"
              xoptionsRepo="vehicles"
              valueProp="id"
              v-model="selectedVehicle"
              captionField="model"
              classModel="assets"
              :extraQueryParams="{archiveLevel:[0,1]}"
              :optionRender="(opt)=>opt.name+(opt.archived?'<span class=\'material-icons\'>delete</span>':'')"></s-remote-select>
        </div>

        <s-select v-if="!displayVehicleRun"
                  placeholder="Φίλτρο πηγης"
                  :options="fuelSrcs"
                  labelProp="name"
                  valueProp="mixedid"
                  filterable
                  clearable
                  large
                  v-model="selectedSrc"></s-select>
      </template>
      <template slot="center" v-if="!displayVehicleRun">
        <el-button
            :disabled="processing"
            type="warning"
            plain
            @click="$refs.fuelTable.appendRecord({ status: 'chk-pump' })"
            title="Ελεγχος αντλιας">
          <i class="material-icons">timeline</i>
        </el-button>
        <el-button
            :disabled="processing"
            type="warning"
            plain
            @click="$refs.fuelTable.appendRecord({ status: 'cr-pump' })"
            title="Διόρθωση αντλιας">
          <i class="material-icons">swap_horiz</i>
        </el-button>
      </template>
      <template slot="right">
        <el-button
            :disabled="processing"
            type="success"
            round
            @click="$refs.fuelTable.appendRecord({ status: 's-vehicle',time:unxnow(),route_id:forRouteId })"
            title="Γεμισμα οχηματος">
          + <i class="material-icons">directions_bus</i>
        </el-button>
      </template>
    </s-toolbar>

    <s-table
        ref="fuelTable"
        v-if="loaded"
        :key="clock"
        v-model="fuelTrans"
        :topOffset="75"
        heightWish="90%"
        :pagging="41"
        :colDefinitions="colDefinitions"
        modx-processor="fuels/getlist"
        :r-query="qFuelTransactions"
        :lazyLoader="true"
        :addEmptyLine="false"
        @cell-input="delayedUpdate"
        @cell-clicked="handleClicks"

        :cellClassFactory="cellDecorator"></s-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import moment from "moment";

export default {
  name: 'VehicleFuels',
  props: {
    formModeState: {type: String, default: null},
    dateRange: {default: null},
    specificAssetId: {type: [String, Number], default: null},
    forRouteId: {type: [String, Number], default: null},
    displayVehicleRun: {type: Boolean, default: false}
  },
  data() {
    return {
      fuelTrans: [],
      printData: null,
      printReady: false,
      loaded: false,
      fuelSrcs: [],
      clock: 0,
      page: 1,
      processing: false,
      searchall: null,
      selectedSrc: null,
      selectedVehicle: null,
      todayArrivals: [],
      todayDepartures: [],
      cols: {},
      dateFormat: "DD/MM/YY"
    };
  },
  methods: {
    delayedUpdate: _.debounce(
        function (e) {
          this.handleFuelTransaction(e);
        },
        650,
        {maxWait: 1200}
    ),
    download() {
      api.ajax_download("fuels/getlist", {
        ...this.qFuelTransactions,
        download: true
      });
    },
    cellDecorator(rowData) {
      var c = "";
      const switchedCols = {
        contact_id: true,
        asset_id: true,
        cost: true,
        load: true,

        klmconusmed: true

        // pumpreading: true,
      };
      if (rowData.row.status == "cr-pump" && rowData.column.property == "load")
        c += " danger";
      if (
          rowData.row.status != "s-vehicle" &&
          switchedCols[rowData.column.property]
      )
        c += " locked";
      if (rowData.column.property == "status") {
        if (rowData.row.status == "cr-pump") c += " danger";
        if (rowData.row.status == "chk-pump") c += " warning";
      }
      if (rowData.column.property == "comments") {
        if (rowData.row.comments && rowData.row.comments.indexOf("!!!") >= 0)
          c += " danger";
      }
      return c;
    },
    handleClose(key, keyPath) {
      _log_(key, keyPath);
    },
    ...mapActions({
      fetchAllOptions: "tags/fetchAll"
    }),
    handleClicks(e) {
      var vm = this;
      _log_("hell.RRs..", e);
      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "refresh_rec")
        this.handleFuelTransaction({...e, prop: e.column.property});
      if (e.column.property == "delete") {
        if (!e.row.id) return;
        this.$confirm(
            "This will permanently delete the record. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        )
            .then(() => {
              api.removeObject("fuels", {objectId: e.row.id});
              vm.removeArrayElement(this.fuelTrans, e.row, "id");
            })
            .catch(() => {
            });
      }
    },
    async addExtraData(rec, prop) {
      const vm = this;
      // _log_(">>>?" + prop, rec);
      if (prop == "asset_id") {
        if (rec.asset_id) {
          const vs = this.getList("vehicles"),
              vo = _.find(vs, {id: rec.asset_id});
          if (vo && vo.drivers[0]) rec.contact_id = vo.drivers[0];
        } else rec.contact_id = null;
      }

      // _log_(">0>>?" + prop, rec);
      if (
          (prop == "load" || prop == "klmconusmed" || prop == "refresh_rec") &&
          rec.asset_id
      ) {
        // _log_(">0>>?go av.." + prop, rec);
        const {data} = await api.fetchProcessor("fuels/getconsumption", rec);
        if (data && data.success) {
          _log_(">0>>?go av.." + rec.comments, rec);
          var comments_parts = [];
          if (rec.comments)
            comments_parts =
                rec.comments.indexOf(":-:") >= 0
                    ? rec.comments.split(":-:")
                    : ["",
                      rec.comments];
          rec.comments =
              "Κατ.:" + vm.formatNumber(data.results.usage) + "L/klm ";
          if (data.results.avg) {
            rec.comments +=
                "(MO:" +
                vm.formatNumber(data.results.avg) +
                // ":" +
                // vm.formatNumber(
                //   Math.abs(data.results.avg - data.results.usage)
                // ) +
                ")";
            if (
                Math.abs(data.results.avg - data.results.usage) /
                data.results.usage >
                0.2
            )
              rec.comments = "!!!" + rec.comments;
          }
          rec.comments += ":-:" + (comments_parts[1] ? comments_parts[1] : "");
        }
        _log_("tynk.AVV.", data);
        return rec;
      }
      //
      if (rec.pump && (rec.status == "s-vehicle" || rec.status == "chk-pump")) {
        const tr = await api.fetchProcessor("fuels/readings", {
          upToDate: rec.time,
          tankId: rec.fuel_src_id,
          checkPump: rec.pump,
          currentLoadId: rec.id
        });

        if (tr && tr.data && tr.data.results) {
          const r = tr.data.results[0];
          if (!r) {
            console.error("problem", r, rec);
            return rec;
          }
          // _log_("tynk.OLEEE.", r);
          const lastReading = parseFloat(r.spumpreading);

          // if (lastReading && rec.load)
          if (lastReading) {
            if (rec.status == "s-vehicle")
              rec.pumpreading =
                  (rec.load ? -Math.abs(parseFloat(rec.load)) : 0) + lastReading;
            // _log_("tynk.GGG..", r.last, r);
            if (rec.status == "chk-pump" && rec.pumpreading) {
              rec.comments =
                  "Διαφορα:" +
                  vm.formatNumber(
                      parseFloat(r.spumpreading) + parseFloat(rec.pumpreading)
                  );
            }
          }
          // _log_("tynk.PPPP..", lastReading, rec);
          // rec.tankLoadBeforeDiff=parseFloat(rec.tankLoadBefore)-
        }
        // _log_("tynk...", rec);
      }
      // _log_("tynk...σσσ", rec);
      return rec;
    },
    async handleFuelTransaction(e) {
      this.processing = true
      let rup = e.row
      // _log_("upd...", this.fuelSrcs, e);
      if (this.specificAssetId)
        rup.asset_id = this.specificAssetId
      else
        rup = await this.addExtraData(rup, e.prop);

      let data = null;
      try {
        data = await api.updateProcessor("fuels/updatevehicle", rup);
      } catch (error) {
        _log_("error saving fuels...", error, error.message);
        this.$notify.error({
          title: "!!!Δεν αποθυκεύτηκε η εγγραφή",
          message: error.message.message
        });
      }
      if (!data) return false;
      if (!_.find(this.fuelSrcs, {mixedid: data.fuel_src_id + ""}))
        this.fuelSrcs.push({
          mixedid: data.fuel_src_id + "",
          name: data.fuelsrc
        });
      // _log_("upd...", data);
      if (data) this.updateArrayElement(this.fuelTrans, data, "id", true);
      this.processing = false
      this.fetchAllOptions(["readings"]);

    },
    async goPrintThis() {
      // var { data } = await api.fetchProcessor("bookings/vuebookings", {
      //   "bookingRange[]": this.bookingRange,
      //   idHotel: this.activeHotel,
      //   searchall: this.searchall,
      //   limit: 0
      // });
      // this.printData = data.results;
      this.loaded = true;
    },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  },
  async mounted() {
    const date = new Date(),
        vm = this
    if (this.displayVehicleRun === false) {
      const fs = this.getList("fuelSrs");
      fs.forEach(fsrc => {
        var src = JSON.parse(JSON.stringify(fsrc));
        if (src.type == "tank") {
          const tid = src.id,
              tn = src.name;
          src.pumps.split(",")
              .forEach(p => {
                src.mixedid = p + ":" + tid;
                src.name = p + ":" + tn;

                vm.fuelSrcs.push(JSON.parse(JSON.stringify(src)));
              });
        } else {
          src.mixedid = "" + src.id;
          vm.fuelSrcs.push(src);
        }
      });
    }
    // _log_("the rs///==>", vm.fuelSrcs);
    // await this.fetchAllOptions();
    // var { data } = await api.fetchProcessor("bookings/vuebookings", {
    //   "bookingRange[]": this.bookingRange,
    //   idHotel: this.activeHotel,
    //   searchall: this.searchall,
    //   dailyView: true,
    //   limit: 0
    // });
    // this.todayDepartures = data.results.departures
    //   ? data.results.departures
    //   : [];
    // this.todayArrivals = data.results.arrivals ? data.results.arrivals : [];
    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    qFuelTransactions() {
      let propRange = null
      if (this.dateRange) {
        propRange = [moment(this.dateRange.start).startOf('day').unix(), moment(this.dateRange.end).endOf('day').unix()]
      }
      return {
        "timeRange[]": propRange || this.fuelsWorkingRange,
        view: this.displayVehicleRun ? "all" : "vehicles",
        routename: this.forRouteId,
        selectedVehicle: this.specificAssetId || this.selectedVehicle,
        selectedSrc: this.selectedSrc,

      };
    },
    ...mapGetters({
      getList: "tags/getList",
      fuelsWorkingRange: "user/fuelsWorkingRange"
    }),
    colDefinitions() {
      const vm = this;
      // _log_('work..',Travel.wdb)
      let rw = "380px",
          fs = this.fuelSrcs;
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      let cs = [
        {
          fixed: "left",
          prop: "status",
          editable: false,
          sortable: false,
          formatter(val, col, row) {
            // _log_('???E..',col,row)
            // return ';;'+row.idx
            if (val == "s-vehicle")
              return '<i class="material-icons">directions_bus</i>';
            if (val == "cr-pump")
              return '<i class="material-icons">swap_horiz</i>';
            if (val == "checkin")
              return '<i class="material-icons">login</i>';
            if (val == "checkout")
              return '<i class="material-icons">logout</i>';
            return '<i class="material-icons">timeline</i>';

          },
          width: "40px",
          label: ""
        },
        {
          prop: "time",
          label: "Η/Μ Ωρα",
          forwardEditOnChange: true,
          editable: true,
          width: "180px",

          formatter(val) {
            if (val) return dateHelper.format(val * 1000, "DD/MM/YYYY , HH:mm");
            return "-";
          },
          editorcomponent: {
            type: "datetime",
            is: "s-dater"
          }
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-vehicle") return true;
            return false;
          },
          prop: "asset_id",
          width: "180px",
          label: "Οχημα",
          editable: true,
          editorcomponent: {
            is: "s-select",
            optionsRepo: "vehicles",
            labelProp: "name",
            valueProp: "id",
            filterable: true,
            clearable: true
          }
          // viewcomponent: {
          //   is: "s-select",
          //   optionsRepo: "vehicles",
          //   labelProp: "name",
          //   valueProp: "id",
          //   viewMode: true
          // }
        },
        {
          prop: "contact_id",
          width: "180px",
          label: "Οδηγος",
          editable: true,
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-vehicle") return true;
            return false;
          },
          editorcomponent: {
            is: "s-select",
            optionsRepo: "drivers",
            labelProp: "name",
            valueProp: "id",
            filterable: true,
            clearable: true
          }
          // viewcomponent: {
          //   is: "s-select",
          //   optionsRepo: "drivers",
          //   labelProp: "name",
          //   valueProp: "id",
          //   viewMode: true
          // }
        },
        {
          prop: "fuelsrc",
          width: "180px",
          label: "Τροφοδοσια",
          editable: true,

          editorcomponent: {
            is: "s-select",
            allowCreate: true,
            options: this.fuelSrcs,
            labelProp: "name",
            valueProp: "mixedid",
            filterable: true,
            clearable: true
          }
          // viewcomponent: {
          //   allowCreate: true,
          //   is: "s-select",
          //   options: this.fuelSrcs,
          //   labelProp: "name",
          //   valueProp: "mixedid",
          //   viewMode: true
          // }
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-vehicle") return true;
            return false;
          },
          prop: "load",
          editable: true,
          width: "180px",
          editorcomponent: {
            is: "s-number"
          },

          formatter(val) {
            return vm.formatNumber(val);
          },
          label: "Φορτ.(Ltr)"

          // editWhen(rowData) {
          //   // _log_('???E..',rowData)
          //   if (rowData.status == "v-sapply") return true;
          //   return false;
          // }
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-vehicle") return true;
            return false;
          },
          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "cost",
          editable: true,
          width: "180px",
          label: "Κοστος(Ε)"
        },

        {
          prop: "klmconusmed",
          formatter(val) {
            return vm.formatNumber(val);
          },
          editorcomponent: {
            is: "s-number",
            digits: 0
          },

          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-vehicle") return true;
            return false;
          },

          editable: true,
          width: "180px",
          label: "ΟΧ.ΧΛΜ"
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "chk-pump" || rowData.status == "cr-pump")
              return true;
            return false;
          },

          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "pumpreading",
          editable: true,
          width: "180px",
          label: "Ενδ.Αντλ."
        },
        {prop: "comments", editable: true, minWidth: "280px", label: "Σχολια"},
        {
          fixed: vm.specificAssetId ? null : "right",
          prop: "refresh_rec",
          width: "60px",
          label: "",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-refresh-right",
            type: "warning",
            circle: true
          }
        },
        {
          fixed: "right",
          prop: "delete",
          width: "60px",
          label: "",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
      ];
      if (Travel.wdb == "travel_") cs.splice(8, 1);
      if (this.displayVehicleRun !== false) cs = cs.filter(c => ['status', 'delete', 'time', 'comments', 'klmconusmed', 'load', 'name'].includes(c.prop))
      _log_('displayVehicleRun', cs)
      return cs;
    }
  }
};
</script>

<style scoped>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

.el-table__row .warning {
  background-color: #e6a23c !important;
  color: white;
}

.el-table__row .danger {
  background-color: #f56c6c !important;
  color: white;
}

.el-table__row .locked {
  background-color: darkgray;
}
</style>
